import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import Image from "next/image";
const SloganModule = (param)=>{
    let { textRow1 , textRow2 , textColor1 , textColor2 , bgImageUrl , className  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("relative flex w-full flex-col items-center justify-center overflow-hidden rounded-lg py-8", "max-sm:rounded-md max-sm:py-3", !bgImageUrl && "border border-gray-200", className),
        children: [
            bgImageUrl && /*#__PURE__*/ _jsx(Image, {
                src: bgImageUrl,
                alt: "",
                fill: true,
                className: "pointer-events-none object-center",
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsx("span", {
                style: {
                    color: textColor1
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h4",
                    className: cn("max-sm:typo-subtitle1 relative text-center", textColor1 && "text-inherit"),
                    children: textRow1
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                style: {
                    color: textColor2
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h4",
                    className: cn("max-sm:typo-subtitle1 relative text-center", textColor2 && "text-inherit"),
                    children: textRow2
                })
            })
        ]
    });
};
export default SloganModule;
